module.exports = __webpack_public_path__ + "static/media/mas_logo.9e29b6f8.webp";